/**
 * Wrapper over Storage which works around some browser bugs.
 *
 * Provides an object with the following keys:
 * - SafeStorage => Access to the class
 * - local => SafeStorage singletone for localStorage
 * - session => SafeStorage singletone for sessionStorage
 */

var _ = require('underscore');
var Backbone = require('backbone');
var MemoryStorage = require('./memorystorage');

var fakeStorage = new MemoryStorage('oberstdorf');


/* Our storage class */
var SafeStorage = function(backend_ident) {
	_.extend(this, Backbone.Events);
	_.bindAll(this, "get", "set", "clear", "remove", "handleError", "storageEventHandler");

	this.looksLikePrivateMode = false;
	this.hasCookiesDisabled = false;
	this.eventGuard = 100;
	this.lastSetValue = null;

	this.backend = fakeStorage;
	this.usingFakeBackend = true;

	/**
	 * localStorage is a piece of shit that can fail even if you just look at it.
	 * So we need to wrap everything that touches it and catch any errors.
	 * Remember: It can fail at really any possible situation.
	 */
	try {
		var maybeBackend;
		switch ( backend_ident ) {
			case 'local': maybeBackend = window.localStorage; break;
			case 'session': maybeBackend = window.sessionStorage; break;
			default: maybeBackend = fakeStorage;
		}

		/* Test the backend */
		var key = "__StorageTest__";
		var value = (new Date()).getTime().toString();
		maybeBackend.setItem(key, value);
		if ( value === maybeBackend.getItem(key) ) {
			maybeBackend.removeItem(key);
		}
		this.backend = maybeBackend;
		this.usingFakeBackend = false;
	}
	catch ( e ) {
		this.handleError(e);
	}

	if ( backend_ident === 'local' && !this.usingFakeBackend ) {
		window.addEventListener('storage', this.storageEventHandler);
	}
};


SafeStorage.prototype.storageEventHandler = function(e) {
	/* e = e.key, e.oldValue */

	/* Nobody cares about that */
	if ( e.key === "TraminoAnalyticsQueue" || e.key === "__StorageTest__" ) return;

	/* Guard against IE bug */
	if ( this.eventGuard <= 0 ) return;

	/* IE triggers 'storage' event in the same tab */
	if ( e.value == this.lastSetValue ) {
		return;
	}
	this.eventGuard--;
	this.trigger('change:' + e.key, e.key, this.backend.getItem(e.key));
};

SafeStorage.prototype.handleError = function(e) {
	this.backend = fakeStorage;
	this.usingFakeBackend = true;

	var knownError = false;

	/* Most browsers sets the Quota to 0 when in private mode */
	if ( e.toString().toLowerCase().indexOf('quota') !== -1 ) {
		this.looksLikePrivateMode = true;
		knownError = true;
	}

	/* German IE */
	if ( e.toString().indexOf('Speicher') !== -1 ) {
		this.looksLikePrivateMode = true;
		knownError = true;
	}

	/* Firefox raises SecurityError when cookies are disabled */
	if ( e.toString().indexOf('SecurityError') !== -1 ) {
		this.hasCookiesDisabled = true;
		knownError = true;
	}

	/*
	if ( !knownError && typeof window.Raven !== "undefined" ) {
		Raven.captureException(e, {
			fingerprint: ['localStorageError'],
		});
	}
	*/
};

SafeStorage.prototype.get = function(key) {
	try {
		var cached = this.backend.getItem(key);
		var ttl = this.backend.getItem(key + "__ttl__");

		if ( !ttl || parseInt(ttl, 10) > (new Date()).getTime() ) {
			return cached;
		}
		return null;
	}
	catch ( e ) {
		this.handleError(e);
		return;
	}
};


SafeStorage.prototype.set = function(key, value, expire) {
	try {
		if ( this.sameTabWorkaround ) {
			this.lastSetValue = value;
		}
		this.backend.setItem(key, value);

		if ( typeof expire !== "undefined" ) {
			this.backend.setItem(
				key + '.__ttl__',
				(new Date()).getTime() + expire
			);
		}
	}
	catch ( e ) {
		this.handleError(e);
		return;
	}
};


SafeStorage.prototype.remove = function(key) {
	try {
		this.backend.removeItem(key);
	}
	catch ( e ) {
		this.handleError(e);
		return;
	}
};


SafeStorage.prototype.clear = function() {
	try {
		this.backend.clear();
	}
	catch ( e ) {
		this.handleError(e);
		return;
	}
};


module.exports = {
	SafeStorage: SafeStorage,
	local: new SafeStorage('local'),
	session: new SafeStorage('session'),
};



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/storage/SafeStorage.js